import { z } from 'zod';

import { OptionEntity } from '@/types/OptionEntity';

export const newsCategorySchema = z.object({
  id: z.union([z.string(), z.number()]),
  name: z.string().optional().nullable(),
});

export type NewsCategoryApi = z.input<typeof newsCategorySchema>;

export const newsCategoryOptionSchema = newsCategorySchema.transform((raw) => {
  const id = Number(raw.id);
  const key = Number.isNaN(id) ? String(raw.id) : id.toString();
  const label = raw.name?.trim();

  const option: OptionEntity<string, string> = {
    key,
    value: label && label.length > 0 ? label : `Категория ${key}`,
  };

  return option;
});

export type NewsCategoryOption = OptionEntity<string, string>;
export type NewsCategoryOptionApi = z.input<typeof newsCategoryOptionSchema>;
